/**
 * MTX API Client
 *
 * This file provides configured instances of all MTX API clients
 * from the @ox/ox-brokerage-client package.
 *
 * The client is auto-generated from apps/mtx/schema/openapi.json
 * To regenerate the client, run: pnpm update-ox-brokerage-client (from js/ directory)
 */

import type { Middleware } from '@ox/ox-brokerage-client';
import { AgentDashboardApi, Configuration, PublicApi, VisitFormsApi, VisitRequestsApi } from '@ox/ox-brokerage-client';

/**
 * Configuration for the MTX API client
 * Points to the same origin as the UI by default
 */
let authToken: string | null = null;

export function setAuthToken(token: string) {
  authToken = token;
}

export function clearAuthToken() {
  authToken = null;
}

// Create a configuration that includes the auth token
const authMiddleware: Middleware = {
  pre: async (context) => {
    if (authToken) {
      return {
        url: context.url,
        init: {
          ...context.init,
          headers: {
            ...context.init.headers,
            Authorization: `Bearer ${authToken}`,
          },
        },
      };
    }

    return context;
  },
};

const config = new Configuration({
  basePath: window.location.origin,
  middleware: [authMiddleware],
});

export const visitRequestsApi = new VisitRequestsApi(config);
export const visitFormsApi = new VisitFormsApi(config);

// Cookie-based config for session-authenticated endpoints (agent dashboard)
const cookieConfig = new Configuration({
  basePath: window.location.origin,
  credentials: 'include',
});

export const publicApi = new PublicApi(cookieConfig);
export const agentDashboardApi = new AgentDashboardApi(cookieConfig);
